import apiClient from ".";
import { ObjectId } from "../models";
import { IOrg, IMembership } from "../models/org";


/**
 * Create a new organization
 * @param body {name: string, description: string}
 * @returns New organization details
 */
export const createOrg = async (body: {name: string, description: string}) => {
	const response = await apiClient.post<IOrg>(`/orgs`, body);
	return response.data;
}
/**
 * Retrieve organization details
 * @param id organization Id 
 * @returns Organization details
 */
export const getOrg = async (id: ObjectId) => {
	const response = await apiClient.get<IOrg>(`/orgs/${id}`);
	return response.data;
};
/**
 * Retrieve all organizations that the logged in user is a member of
 * @returns Array of organizations
 */
export const getOrgs = async () => {
	const response = await apiClient.get<IOrg[]>(`/orgs`);
	return response.data;
}
/**
 * Update organization details
 * @param body {id: ObjectId, name: string, description: string}
 * @returns Updated organization
 */
export const updateOrg = async (body: {id: ObjectId, name: string, description: string}) => {
	const response = await apiClient.patch<IOrg>(`/orgs/${body.id}`, body);
	return response.data;
}
/**
 * Delete organization
 * @param id organization Id
 * @returns Deleted organization
 */
export const deleteOrg = async (id: ObjectId) => {
	const response = await apiClient.delete<IOrg>(`/orgs/${id}`);
	return response.data;
}

// Members
/**
 * Retrieve membership details for logged in user
 * @param orgId organization Id
 * @returns User membership details
 */
export const getMembership = async (orgId: ObjectId) => {
	const response = await apiClient.get<IMembership>(`/orgs/${orgId}/membership`);
	return response.data;
}
/**
 * Retrieve all members of an organization
 * @param orgId organization Id
 * @returns Array of organization members
 */
export const getOrgMembers = async (orgId: ObjectId) => {
	const response = await apiClient.get<IMembership[]>(`/orgs/${orgId}/members`);
	return response.data;
}
/**
 * Update member role
 * @param body {orgId: ObjectId, id: ObjectId, role: string}
 * @returns Updated organization
 */
export const updateMemberRole = async (body: {orgId: ObjectId, id: ObjectId, role: string}) => {
	const response = await apiClient.patch<IMembership>(`/orgs/${body.orgId}/members/${body.id}`, body);
	return response.data;
}
/**
 * Disable member
 * @param body {orgId: ObjectId, id: ObjectId}
 * @returns Updated organization
 */
export const disableMember = async (body: {orgId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.patch<IMembership>(`/orgs/${body.orgId}/members/${body.id}/disable`, body);
	return response.data;
}
/**
 * Delete member
 * @param body {orgId: ObjectId, id: ObjectId}
 * @returns Updated organization
 */
export const deleteMember = async (body: {orgId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.delete<IMembership>(`/orgs/${body.orgId}/members/${body.id}`);
	return response.data;
}

// Invitations
export const inviteMember = async (body: {orgId: ObjectId, email: ObjectId, role: string}) => {
	const response = await apiClient.post<IMembership>(`/orgs/${body.orgId}/invitations`, body);
	return response.data;
}
export const acceptInvitation = async (body: {token: string}) => {
	const response = await apiClient.post(`/orgs/invitations/accept`, body);
	return response.data;
}
export const getOrgInvitations = async (orgId: ObjectId) => {
	const response = await apiClient.get<IMembership[]>(`/orgs/${orgId}/invitations`);
	return response.data;
}
export const updateInvite = async (body: {orgId: ObjectId, id: ObjectId, role: string}) => {
	const response = await apiClient.patch<IMembership>(`/orgs/${body.orgId}/invitations/${body.id}`, body);
	return response.data;
}
export const deleteInvite = async (body: {orgId: ObjectId, id: ObjectId}) => {
	const response = await apiClient.delete<IMembership>(`/orgs/${body.orgId}/invitations/${body.id}`);
	return response.data;
}